"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountries = void 0;
var react_1 = require("react");
var template_1 = require("@artegeie/mona-sdk/template");
var useLocale_1 = __importDefault(require("./useLocale"));
var useCountries = function () {
    var locale = (0, useLocale_1.default)().locale;
    var _a = (0, react_1.useState)([]), countries = _a[0], setCountries = _a[1];
    (0, react_1.useEffect)(function () {
        (0, template_1.getCountries)(locale)
            .then(function (countries) { return countries.map(function (country) { return ({
            label: country.name,
            value: country.name,
        }); }); })
            .then(setCountries)
            .catch(function () { return setCountries([]); });
    }, []);
    return countries;
};
exports.useCountries = useCountries;
exports.default = exports.useCountries;
